import { render, staticRenderFns } from "./ChangeMyPassword.vue?vue&type=template&id=f9b5c3d0&lang=pug&"
import script from "./ChangeMyPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeMyPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports